/**
 * @deprecated Use ./beneficiaries
 */
export * from './beneficiaries';
